"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.randomBytes = void 0;

var sync_randombytes_1 = __importDefault(require("@consento/sync-randombytes"));

exports.sha256 = __importStar(require("fast-sha256"));
exports.aes = __importStar(require("micro-aes-gcm"));

__exportStar(require("./interfaces"), exports);

exports.keys = __importStar(require("./keys"));

var utils_1 = require("./utils");

Object.defineProperty(exports, "multihash", {
  enumerable: true,
  get: function get() {
    return utils_1.multihash;
  }
});
Object.defineProperty(exports, "sha256Multihash", {
  enumerable: true,
  get: function get() {
    return utils_1.sha256Multihash;
  }
});

exports.randomBytes = function (byteLength) {
  return sync_randombytes_1.default(new Uint8Array(byteLength));
};